// Performance optimization configuration 
export const PERFORMANCE_CONFIG = {
  // Enable/disable specific optimizations
  optimizations: {
    // Disable complex animations on low-end devices
    disableComplexAnimations: true,
    
    // Use reduced shadow complexity
    reduceShadows: true,
    
    // Lazy load heavy components
    lazyLoadComponents: true,
    
    // Limit concurrent animations
    limitConcurrentAnimations: true,
    
    // Use InteractionManager for deferred tasks
    deferNonCriticalTasks: true,
    
    // Enable memoization for expensive renders
    enableMemoization: true,
  },
  
  // Visual effects configuration
  visuals: {
    // Enable/disable glow effect on featured items
    glowEnabled: true,
    
    // Glow opacity (0-1) - reduced for more subtle effect
    glowOpacity: 0.08,
    
    // Enable/disable rainbow border animation
    rainbowBorderEnabled: true,
  },
  
  // Animation settings
  animations: {
    // Maximum animation duration (ms)
    maxDuration: 5000,
    
    // Default duration multiplier for low-end devices
    lowEndMultiplier: 0.5,
    
    // Disable animations below this FPS threshold
    fpsThreshold: 30,
  },
  
  // Shadow settings
  shadows: {
    // Maximum shadow radius
    maxRadius: 10,
    
    // Maximum shadow opacity
    maxOpacity: 0.2,
    
    // Maximum elevation (Android)
    maxElevation: 5,
  },
  
  // Component loading settings
  loading: {
    // Components to lazy load
    lazyComponents: [
      'OpportunityDetail',
      'CalendarView',
      'AdminPanel',
    ],
    
    // Delay before showing loading indicator (ms)
    loadingDelay: 300,
  },
  
  // Debug settings
  debug: {
    // Show performance monitor in development
    showPerformanceMonitor: process.env.NODE_ENV === 'development',
    
    // Log performance metrics
    logMetrics: false,
  },
}; 
